import { useFeatureFlag } from 'featureFlags/hooks/useFeatureFlag'
import { FeatureFlag } from 'shared/enums/FeatureFlag'
import GuestCheckoutAuth from './GuestCheckoutAuth'
import Auth from './Auth'

const AuthPanel = () => {
  const isGuestCheckout = useFeatureFlag(FeatureFlag.GUEST_CHECKOUT)
  return isGuestCheckout ? <GuestCheckoutAuth /> : <Auth />
}

export default AuthPanel
